import React from "react";
import { useSdkContext } from "scmp-sdk/components/contexts";
import { useNewsletterContext } from "scmp-sdk/components/newsletter/newsletter-widget/contexts";
import { getNewsletterTitle } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/helpers";

import SvgGenericIcon from "./img-generic-icon.svg";
import SvgGlobalImpact from "./img-global-impact.svg";
import SvgLunar from "./img-lunar.svg";
import SvgPostMag from "./img-post-mag.svg";
import SvgThisWeekInAsia from "./img-twia.svg";
import { Container, Description, ImageContainer, Title } from "./styles";

export const Article20ThemeTitle: React.FunctionComponent = () => {
  const { config } = useSdkContext();
  const { newsletterItemForDisplay } = useNewsletterContext();

  const newsletterSvgMap = {
    [config.newsletter.globalImpact]: <SvgGlobalImpact />,
    [config.newsletter.lunar]: <SvgLunar />,
    [config.newsletter.postMag]: <SvgPostMag />,
    [config.newsletter.thisWeekInAsia]: <SvgThisWeekInAsia />,
  };

  const computedNewsletterTitle = getNewsletterTitle(newsletterItemForDisplay);

  const newsletterId = newsletterItemForDisplay?.entityId ?? "";
  const renderContent = () => {
    if (newsletterId in newsletterSvgMap) {
      return newsletterSvgMap[newsletterId];
    }

    return computedNewsletterTitle;
  };
  return (
    <Container>
      <Title>{renderContent()}</Title>
      <Description>{newsletterItemForDisplay?.description?.text}</Description>
      <ImageContainer>
        <SvgGenericIcon />
      </ImageContainer>
    </Container>
  );
};

Article20ThemeTitle.displayName = "Article20ThemeTitle";
